<template>
  <div :class="circleClass">
    <slot/>
  </div>
</template>

<script>
import {
  COLOR_CALM,
  COLOR_DANGER,
  COLOR_GRAY_600,
  COLOR_PRIMARY,
  COLOR_SUCCESS,
  SIZE_SM,
} from '../../config/constants';
import { CIRCLE_BASE_CLASS, CIRCLE_COLORS, CIRCLE_SIZES } from './config';

export default {
  name: 'DpCircle',

  props: {
    /**
     * @values white, primary, primary-light, success, success-light, danger, danger-light, warning, warning-light,
     * calm, calm-light, gray-300, gray-600
     * */
    color: {
      required: false,
      type: String,
      default: null,
      validator: (value) => CIRCLE_COLORS.includes(value),
    },
    /**
     * @values xs, sm, md, lg, xl
     * @default sm
     * */
    size: {
      required: false,
      type: String,
      default: SIZE_SM,
      validator: (value) => !value || CIRCLE_SIZES.includes(value),
    },
  },

  computed: {
    circleClass() {
      const classes = [CIRCLE_BASE_CLASS];
      const { color, size } = this;
      const circleWithWhiteText = [
        COLOR_CALM,
        COLOR_GRAY_600,
        COLOR_DANGER,
        COLOR_SUCCESS,
        COLOR_PRIMARY,
      ];

      if (color) {
        classes.push(`circle-${color}`);
      }

      if (size && size !== SIZE_SM) {
        classes.push(`circle-size-${size}`);
      }

      if (circleWithWhiteText.includes(color)) {
        classes.push('text-white');
      }

      return classes;
    },
  },
};
</script>
